import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VerProductoRoutingModule } from './ver-producto-routing.module';
import { VerProductoComponent } from './ver-producto.component';
import {MatDividerModule} from '@angular/material/divider';
import {MatTabsModule} from '@angular/material/tabs';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {FormsModule} from '@angular/forms';
import {MatTooltipModule} from '@angular/material/tooltip';
import {UiModule} from '../../../ui/ui.module';
import {MatIconModule} from "@angular/material/icon";
import {GalleriaModule} from "primeng-lts/galleria";


@NgModule({
  declarations: [VerProductoComponent],
    imports: [
        CommonModule,
        VerProductoRoutingModule,
        MatDividerModule,
        MatTabsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        FormsModule,
        MatTooltipModule,
        UiModule,
        MatIconModule,
        GalleriaModule
    ]
})
export class VerProductoModule { }
